import React, { useContext, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { emailRegex } from "../../../utils/regex";
import "../../../stylesheets/components/dowloadHoldingReports/DPtransactionFormDesk.scss";
import moment from "moment";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { useSelector } from "react-redux";
import DeviceContext from "../../../utils/indentifyDevice";
import CalendarYealryPopupDesk from "../Calendar/CalendarYearlyPopup";
import { enterMail, validMail } from "@domains/utils/commonText";
import { getFinancialYear, pnlDownloadDate, previousDay, } from "@domains/utils/reportDates";
import { storeEmailListInSessionStorage } from "@domains/utils/sessionMethods";
import SelectDropdown from "../selectdropdown";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { useParams } from "react-router-dom";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { EOtherReportTabs } from "@frameworks/web/components/Reports/CommonComponent/constant";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
export var DownloadEnumReportType;
(function (DownloadEnumReportType) {
    DownloadEnumReportType["PNL"] = "pnlReport";
    DownloadEnumReportType["HOLDING_REPORT"] = "holdingReport";
    DownloadEnumReportType["TAX"] = "taxReport";
})(DownloadEnumReportType || (DownloadEnumReportType = {}));
export const avoidPANProtectionMessage = [EOtherReportTabs.CONTRACT_NOTES];
const DownloadReportPopupDesk = (props) => {
    var _a, _b, _c, _d;
    const webConfig = useContext(WebConfigContext);
    const { loginOrigin } = useParams();
    const salesNativeApp = JSON.parse(localStorage.getItem("sales_native_app"));
    const sales_jwt_token = localStorage.getItem("sales_jwt_token");
    const isRMApp = (Boolean(window.self !== window.top) && sales_jwt_token) || salesNativeApp;
    const activeSubTabOtherReport = getQueryParameterName("tab");
    const financialYear = getFinancialYear(new Date());
    const [fromDate, setFromDate] = useState(props.startDate);
    const [toDate, setToDate] = useState(props.endDate);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const [PDF_or_Excel, setPDForExcel] = useState((props === null || props === void 0 ? void 0 : props.PDF_or_Excel) ? props === null || props === void 0 ? void 0 : props.PDF_or_Excel : null);
    const [isIconDisabled, setIsIconDisabled] = useState(true);
    const [selectedDateRange, setSelectedDateRange] = useState("startDateSelected");
    const [emailList, setEmailList] = useState([]);
    const [currEmailvalue, setCurrEmailValue] = useState();
    const _startcalendar = useRef(null);
    const _endcalendar = useRef(null);
    const [openCalendarBetween, setOpenCalendarBetween] = React.useState(false);
    const inputRef = useRef(null);
    const sessionEmailList = sessionStorage.getItem("emailList");
    const calenderYRef = useRef(null);
    const emailStatus = useSelector((state) => { var _a; return (_a = state[props.reportType]) === null || _a === void 0 ? void 0 : _a.emailStatus; });
    const downloadStatus = useSelector((state) => { var _a; return (_a = state[props.reportType]) === null || _a === void 0 ? void 0 : _a.downloadStatus; });
    const defaultEmailId = useSelector((state) => state.accountDetailsReducer.emaildId);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const startDatePicker = (e) => {
        if (_startcalendar.current) {
            _startcalendar.current.setOpen(true);
        }
    };
    const endDatePicker = (e) => {
        if (_endcalendar.current) {
            _endcalendar.current.setOpen(true);
        }
    };
    const isAdditionalMsg = (props === null || props === void 0 ? void 0 : props.isAdditionalMsg)
        ? props === null || props === void 0 ? void 0 : props.isAdditionalMsg(fromDate, toDate)
        : null;
    const isClientLogin = loginOrigin !== LoginSource.SALES &&
        !salesNativeApp &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    useEffect(() => {
        if (defaultEmailId && !emailList.includes(defaultEmailId)) {
            let defaultEmailList = [defaultEmailId];
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = defaultEmailList;
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
        else {
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = emailList && emailList.length > 0 ? emailList : [];
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    if (!emailList.includes(emailId))
                        finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
    }, [defaultEmailId, emailCheck]);
    useEffect(() => {
        if (fromDate && toDate && PDF_or_Excel && (emailCheck || downloadCheck)) {
            if ((emailCheck && emailList.length > 0) || downloadCheck)
                setSubmitDisabled(true);
            else
                setSubmitDisabled(false);
            if (props.showDPIDDropDown && props.selectedDpId == null)
                setSubmitDisabled(false);
        }
        else if (PDF_or_Excel && (emailCheck || downloadCheck)) {
            if (emailCheck && emailList.length > 0)
                setSubmitDisabled(true);
            else if (downloadCheck && emailCheck && emailList.length > 0)
                setSubmitDisabled(true);
            else if (downloadCheck && !emailCheck)
                setSubmitDisabled(true);
            else
                setSubmitDisabled(false);
            if (props.showDPIDDropDown && props.selectedDpId == null)
                setSubmitDisabled(false);
        }
        else
            setSubmitDisabled(false);
        if (props.setEmailCheck)
            props.setEmailCheck(emailCheck);
        if (props.setDownloadCheck)
            props.setDownloadCheck(downloadCheck);
    }, [
        emailCheck,
        emailList,
        downloadCheck,
        PDF_or_Excel,
        fromDate,
        toDate,
        props.showDPIDDropDown,
        props.selectedDpId,
        props.selectedDpType,
    ]);
    const EmailListUpdate = () => {
        if (emailRegex.test(currEmailvalue) &&
            !emailList.includes(currEmailvalue)) {
            storeEmailListInSessionStorage(currEmailvalue, sessionEmailList, true);
            setEmailList([...emailList, currEmailvalue]);
            setCurrEmailValue("");
            return [...emailList, currEmailvalue];
        }
        return [];
    };
    const dateChange = (dates) => {
        const [start, end] = dates;
        setFromDate(start);
        setToDate(end);
        setSelectedDateRange(end ? "startDateSelected" : "endDateSelected");
        if (end) {
            setOpenCalendarBetween(false);
        }
    };
    useEffect(() => {
        if (((emailStatus && (emailStatus === null || emailStatus === void 0 ? void 0 : emailStatus.isOpen) !== null) ||
            (downloadStatus && (downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) !== null)) &&
            props.showLoader &&
            (emailCheck || downloadCheck)) {
            props.setShowLoader(false);
            if ((emailCheck && (emailStatus === null || emailStatus === void 0 ? void 0 : emailStatus.isOpen) === true) ||
                (downloadCheck && (downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) === true)) {
                props.setDownloadSuccess(true);
            }
            else {
                props.setDownloadFail(true);
            }
        }
    }, [emailStatus === null || emailStatus === void 0 ? void 0 : emailStatus.isOpen, downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen]);
    const handleSubmit = (e) => {
        var _a, _b, _c;
        e.preventDefault();
        props.setShowLoader(true);
        let emailFormat, downloadFormat = undefined;
        if (downloadCheck) {
            downloadFormat = {
                fromDate: moment(fromDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
            };
            if (props.assetType) {
                downloadFormat.assetType = props.assetType;
            }
            if (props.withEndDate) {
                downloadFormat.toDate = moment(toDate).format("yyyy-MM-DD");
            }
            if (props.currYear) {
                downloadFormat.financialYear = "FY" + props.currYear.toString();
            }
            if (props.urlParts)
                downloadFormat.urlParts = props.urlParts;
            if (props.usetaxDPURL)
                downloadFormat.usetaxDPURL = props.usetaxDPURL;
            if (props.selectedDpId)
                downloadFormat.dpId = props.selectedDpId;
            if (props.selectedDpType)
                downloadFormat.dpType = props.selectedDpType;
            if (props === null || props === void 0 ? void 0 : props.accodes)
                downloadFormat.accodes = props === null || props === void 0 ? void 0 : props.accodes;
            if (props === null || props === void 0 ? void 0 : props.isTaxHarvesting)
                downloadFormat = {
                    accodes: props === null || props === void 0 ? void 0 : props.accodes,
                    reportType: PDF_or_Excel,
                    reportName: ReportName.TAX_HARVESTING,
                    taxHarvesting: "harvesting",
                };
            (_a = props === null || props === void 0 ? void 0 : props.setOperation) === null || _a === void 0 ? void 0 : _a.call(props, "download");
        }
        if (emailCheck) {
            let list = emailList;
            if (emailList.length === 0 && currEmailvalue.length > 3) {
                list = EmailListUpdate();
            }
            emailFormat = {
                fromDate: moment(fromDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
                emailIds: list,
            };
            if (props.assetType) {
                emailFormat.assetType = props.assetType;
            }
            if (props.withEndDate) {
                emailFormat.toDate = moment(toDate).format("yyyy-MM-DD");
            }
            if (props.currYear) {
                emailFormat.financialYear = "FY" + props.currYear.toString();
            }
            if (props.urlParts)
                emailFormat.urlParts = props.urlParts;
            if (props.usetaxDPURL)
                emailFormat.usetaxDPURL = props.usetaxDPURL;
            if (props.selectedDpId && props.showDPIDDropDown)
                emailFormat.dpId = props.selectedDpId;
            if (props.selectedDpType)
                emailFormat.dpType = props.selectedDpType;
            if (props === null || props === void 0 ? void 0 : props.isTaxHarvesting) {
                emailFormat = {
                    emailIds: list,
                    taxHarvesting: "harvesting",
                    isPwdProtected: true,
                };
            }
            if (props.accodes)
                emailFormat.accodes = props.accodes;
            (_b = props === null || props === void 0 ? void 0 : props.setOperation) === null || _b === void 0 ? void 0 : _b.call(props, "email");
        }
        if (downloadCheck && emailCheck) {
            (_c = props === null || props === void 0 ? void 0 : props.setOperation) === null || _c === void 0 ? void 0 : _c.call(props, "email_download");
        }
        props.submit(emailFormat, downloadFormat);
    };
    useEffect(() => {
        function handleClickOutside(event) {
            if (calenderYRef.current &&
                !calenderYRef.current.contains(event.target)) {
                props.setOpenCalendar(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [calenderYRef]);
    React.useEffect(() => {
        setFromDate(props.startDate);
        if (props.withEndDate)
            setToDate(props.endDate);
    }, [props.startDate, props.endDate]);
    React.useEffect(() => {
        if (props === null || props === void 0 ? void 0 : props.resetFields) {
            setEmailCheck(false);
            setDownloadCheck(false);
            setPDForExcel((props === null || props === void 0 ? void 0 : props.PDF_or_Excel) ? props === null || props === void 0 ? void 0 : props.PDF_or_Excel : null);
            setCurrEmailValue("");
            setEmailList([]);
            setFromDate(props.startDate);
            setToDate(props.endDate);
            setOpenCalendarBetween(false);
        }
    }, [props === null || props === void 0 ? void 0 : props.resetFields]);
    useEffect(() => {
        const trimmedValue = (currEmailvalue === null || currEmailvalue === void 0 ? void 0 : currEmailvalue.trim()) || "";
        const isValueEmpty = trimmedValue === "";
        const isValidEmail = emailRegex.test(trimmedValue);
        setCurrEmailValue(trimmedValue);
        setIsIconDisabled(isValueEmpty || !isValidEmail);
    }, [currEmailvalue, emailRegex]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "customForm common-download-newtheme" },
            !!isAdditionalMsg && (React.createElement("div", { className: "bg_old-lace p-10 mb-1" },
                React.createElement("span", { className: "DMSanN_14_400 txt-orange-light" }, isAdditionalMsg))),
            React.createElement("form", { className: "customFormSection", onSubmit: (e) => handleSubmit(e), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        if (!currEmailvalue && submitDisabled) {
                            handleSubmit(e);
                        }
                    }
                } },
                React.createElement("div", null,
                    React.createElement("div", { className: "" },
                        !props.showdate && (React.createElement("div", { className: "customFormSection_field dateWrap" },
                            React.createElement("div", { className: "row" }, props.withEndDate ? (React.createElement("div", { className: "col-md-12 col-lg-12 common-download-report" },
                                React.createElement("div", { className: "date-input-section boder-bottom" },
                                    React.createElement("div", { className: `DMSanM_14_500 ${selectedDateRange === "startDateSelected"
                                            ? "txt-midight-blue"
                                            : "txt-secondary-gray"}` },
                                        React.createElement("label", { htmlFor: "date", className: "label" }, "From Date"),
                                        React.createElement("div", { className: "input-group yearDropdown common-datepicker", onClick: () => {
                                                setOpenCalendarBetween(true);
                                            } },
                                            React.createElement("input", { type: "text", className: `date-drawer-input-field  ${selectedDateRange === "startDateSelected"
                                                    ? "txt-midight-blue"
                                                    : "txt-secondary-gray"}`, value: moment(fromDate).format("D-MMM-YY") }),
                                            React.createElement("a", { className: "input-group-append", onClick: startDatePicker },
                                                React.createElement("span", { className: "input-group-text d-block" },
                                                    React.createElement("i", { className: "edel-icon-calendar-report" }))))),
                                    React.createElement("div", { className: `DMSanM_14_500 ${selectedDateRange === "endDateSelected"
                                            ? "txt-midight-blue"
                                            : "txt-secondary-gray"}

                     ` },
                                        React.createElement("label", { htmlFor: "date", className: "label" }, "To Date"),
                                        React.createElement("div", { className: "input-group yearDropdown common-datepicker", onClick: () => {
                                                setOpenCalendarBetween(true);
                                            } },
                                            React.createElement("input", { type: "text", className: `date-drawer-input-field ${selectedDateRange === "endDateSelected"
                                                    ? "txt-midight-blue"
                                                    : "txt-secondary-gray"}`, value: selectedDateRange === "endDateSelected"
                                                    ? "Select End Date"
                                                    : moment(toDate).format("D-MMM-YY") }),
                                            React.createElement("a", { className: "input-group-append", onClick: endDatePicker },
                                                React.createElement("span", { className: "input-group-text d-block" },
                                                    React.createElement("i", { className: "edel-icon-calendar-report" })))))),
                                openCalendarBetween && (React.createElement("div", { className: "pdt-20 yearDropdown singleDatePicker holdingReportsDate rangeDatePickerContainer" },
                                    React.createElement(DatePicker, { scrollableYearDropdown: true, selected: fromDate, dateFormat: "d-MMM-yy", onChange: dateChange, startDate: fromDate, endDate: toDate, selectsRange: true, inline: true, maxDate: previousDay, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), showYearDropdown: true, showMonthDropdown: true, minDate: props.minDate ? props.minDate : pnlDownloadDate, yearDropdownItemNumber: props.minDate
                                            ? previousDay.getFullYear() -
                                                props.minDate.getFullYear() +
                                                1
                                            : previousDay.getFullYear() -
                                                pnlDownloadDate.getFullYear() +
                                                1 }))))) : (React.createElement("div", { className: "col-md-12 col-lg-12" },
                                React.createElement("label", { htmlFor: "date", className: "form-label" }, "Date"),
                                React.createElement("div", { className: "" },
                                    React.createElement("div", { className: "input-group", ref: calenderYRef },
                                        props.TaxDownload ? (React.createElement(React.Fragment, null,
                                            React.createElement("label", { htmlFor: "date", className: "form-label" },
                                                React.createElement("b", null,
                                                    "FY ",
                                                    props.finYear,
                                                    "-",
                                                    (props.finYear + 1)
                                                        .toString()
                                                        .substring(2))),
                                            DeviceContext().isDesktop && (React.createElement("div", null,
                                                React.createElement(CalendarYealryPopupDesk, { finYear: props.finYear, setFinYear: props.setFinYear, currYear: props.currYear, setCurrYear: props.setCurrYear, years: props.years, openYear: props.openCalendar, setOpenYear: props.setOpenCalendar, extenalClassName: "year_container_top" }))))) : (React.createElement(DatePicker, { selected: fromDate, onChange: (date) => setFromDate(date), ref: _startcalendar, dateFormat: "d-MMM-yy", scrollableYearDropdown: true, yearDropdownItemNumber: props.minDate
                                                ? previousDay.getFullYear() -
                                                    props.minDate.getFullYear() +
                                                    1
                                                : previousDay.getFullYear() -
                                                    pnlDownloadDate.getFullYear() +
                                                    1 })),
                                        props.TaxDownload ? (React.createElement("a", { className: "input-group-append", onClick: () => props.setOpenCalendar(!props.openCalendar) },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                React.createElement("span", null, "Change")))) : (React.createElement("a", { className: "input-group-append", onClick: startDatePicker },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                React.createElement("span", null, "Change"))))))))))),
                        (props === null || props === void 0 ? void 0 : props.isTaxHarvesting) && (React.createElement("div", { className: "customFormSection_field financial-year-block-download-report" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Financial Year"),
                            React.createElement("div", { className: "DMSansMedium_16_500 txt_black_one1" },
                                "FY ",
                                financialYear,
                                "-",
                                (financialYear + 1).toString().substring(2)))),
                        (props === null || props === void 0 ? void 0 : props.showDPIDDropDown) && !(props === null || props === void 0 ? void 0 : props.isTaxHarvesting) && (React.createElement("div", { className: "customFormSection_field pt-4" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "DP ID"),
                            React.createElement(SelectDropdown, { id: "selectoption", selected: true, defaultValue: (_a = props === null || props === void 0 ? void 0 : props.dpIds[0]) === null || _a === void 0 ? void 0 : _a.value, selectedValue: props.selectedDpId
                                    ? props.selectedDpId
                                    : (_b = props === null || props === void 0 ? void 0 : props.dpIds[0]) === null || _b === void 0 ? void 0 : _b.value, options: props === null || props === void 0 ? void 0 : props.dpIds, onChangeEvent: (e) => props.setDpId(e), className: "CustomCommonDropdown", downarrow: "edel-icon-arrow-down", dropdownOptions: props === null || props === void 0 ? void 0 : props.dpIds, placeholderClassName: "" }))),
                        !(props === null || props === void 0 ? void 0 : props.isTaxHarvesting) && (React.createElement("div", { className: "customFormSection_field boder-bottom " },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Report Format"),
                            React.createElement("div", { className: `${(_d = (_c = props === null || props === void 0 ? void 0 : props.themeClass) === null || _c === void 0 ? void 0 : _c.radio) !== null && _d !== void 0 ? _d : "radio"}` },
                                !(props === null || props === void 0 ? void 0 : props.showPdfIcon) && (React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: () => setPDForExcel(ReportType.PDF), required: true, checked: PDF_or_Excel !== null &&
                                            PDF_or_Excel === ReportType.PDF
                                            ? true
                                            : false }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault1" }, "PDF"))),
                                !props.hideExcel && (React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: () => {
                                            setPDForExcel(ReportType.EXCEL);
                                            (isImpersonated || isRMApp) &&
                                                setDownloadCheck(false);
                                        }, required: true, 
                                        // disabled={isImpersonated && lgnSrc !== "nesttrader"}
                                        checked: PDF_or_Excel !== null &&
                                            PDF_or_Excel === ReportType.EXCEL
                                            ? true
                                            : false }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault2" }, "Excel")))))),
                        React.createElement("div", { className: "customFormSection_field checkboxWrap" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Get Report As"),
                            React.createElement("div", { className: "checkbox" },
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "downloadcheckbtn", checked: (isImpersonated || isRMApp) &&
                                            PDF_or_Excel === ReportType.EXCEL
                                            ? false
                                            : downloadCheck, disabled: (isImpersonated || isRMApp) &&
                                            lgnSrc !== ELoginSource.NESTTRADER &&
                                            PDF_or_Excel &&
                                            PDF_or_Excel === ReportType.EXCEL, onChange: (e) => {
                                            if ((isImpersonated || isRMApp) &&
                                                PDF_or_Excel === ReportType.EXCEL)
                                                setDownloadCheck(false);
                                            else
                                                setDownloadCheck(e.target.checked);
                                        } }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "downloadcheckbtn" },
                                        React.createElement("span", { className: (isImpersonated || isRMApp) &&
                                                PDF_or_Excel === ReportType.EXCEL
                                                ? "txt_secondary-gray"
                                                : "" }, "Download"))),
                                props.avoidEMail ? null : (React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "emailcheckbtn", checked: emailCheck, onChange: (e) => {
                                            setEmailCheck(e.target.checked);
                                        } }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "emailcheckbtn" }, "Email"))))),
                        emailCheck && (React.createElement("div", { className: "customFormSection_field" },
                            React.createElement("div", { className: "blue_bg mail change-bg-white" },
                                emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                    React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                        return (React.createElement("li", { key: idx, className: "mail_label_body_item" },
                                            React.createElement("div", { className: "text-truncate" }, el),
                                            React.createElement("span", { className: "mail_label_close", onClick: () => {
                                                    setEmailList((emailList) => emailList.filter((_, i) => emailList[i] !== el));
                                                    storeEmailListInSessionStorage(el, sessionEmailList, false);
                                                } },
                                                React.createElement("i", { className: "edel-icon-rounded-close" }))));
                                    })))),
                                React.createElement("div", { className: "mail-input" },
                                    React.createElement("input", { ref: inputRef, type: "email", className: "form-control", placeholder: "Enter email address", disabled: isImpersonated || lgnSrc == "nesttrader", pattern: emailRegex.source, value: currEmailvalue, onChange: (e) => {
                                            const trimmedValue = e.target.value.trim();
                                            const isValueEmpty = trimmedValue === "";
                                            const isValidEmail = emailRegex.test(trimmedValue);
                                            setCurrEmailValue(trimmedValue);
                                            setIsIconDisabled(isValueEmpty || !isValidEmail);
                                        }, required: emailCheck && emailList.length === 0, onInvalid: (e) => {
                                            if (e.currentTarget.validity.valueMissing) {
                                                return e.currentTarget.setCustomValidity(enterMail);
                                            }
                                            if (e.currentTarget.validity.patternMismatch) {
                                                return e.currentTarget.setCustomValidity(validMail);
                                            }
                                        }, onKeyDown: (e) => {
                                            if (e.key === "Enter" &&
                                                !isImpersonated &&
                                                lgnSrc !== "nesttrader") {
                                                e.preventDefault();
                                                EmailListUpdate();
                                                if (inputRef && inputRef.current) {
                                                    inputRef.current.checkValidity();
                                                    inputRef.current.reportValidity();
                                                    setIsIconDisabled(currEmailvalue === "");
                                                }
                                            }
                                        } }),
                                    React.createElement("div", { className: `icon ${isIconDisabled ||
                                            isImpersonated ||
                                            lgnSrc == "nesttrader"
                                            ? "icon-disabled"
                                            : ""}`, onClick: () => {
                                            if (currEmailvalue &&
                                                !isImpersonated &&
                                                lgnSrc !== "nesttrader") {
                                                EmailListUpdate();
                                                if (inputRef && inputRef.current) {
                                                    inputRef.current.checkValidity();
                                                    inputRef.current.reportValidity();
                                                    setIsIconDisabled(!emailRegex.test(currEmailvalue));
                                                }
                                            }
                                        } },
                                        React.createElement("i", { className: `edel-icon-add ${(isImpersonated || lgnSrc == "nesttrader") &&
                                                "pe-none user-select-auto txt_monochromeGrey"}` })))))),
                        !isClientLogin &&
                            !avoidPANProtectionMessage.includes(activeSubTabOtherReport) && (React.createElement("div", { className: "my-4" },
                            React.createElement(PANPassword, null)))),
                    React.createElement("div", { className: "remove-button-report" },
                        React.createElement("button", { className: "btn midnight-blue custom_btn", type: "submit", disabled: props.customDisableSubmit
                                ? props.customDisableSubmit(fromDate, toDate) ||
                                    !submitDisabled
                                : !submitDisabled }, props.submitBtnText ? props.submitBtnText : "Submit")))))));
};
export default DownloadReportPopupDesk;
